import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Purpose } from '../../models/purpose';
import { PurposeService } from '../../services/purpose.service';
import { CommitteeService } from '../../services/committee.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-purpose',
  templateUrl: './purpose.component.html',
  styleUrls: ['./purpose.component.css']
})

export class PurposeComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerPurpose: PageHeader;
  entity: Purpose = new Purpose();
  selectedPurpose: Purpose = new Purpose();
  editingEntity: Purpose = new Purpose();
  Purpose: any;
  PurposeColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  locations: Array<Location> = [];
  selectedLocation: any;
  _selectedPurpose: any;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  departments: Array<Department> = [];
  pipe = new DatePipe('en-US');
  opened: boolean = false;
  details: any;
  constructor(
    private _departmentService: DepartmentService,
    private _PurposeService: PurposeService,
    private _committeeService: CommitteeService,
    private _locationService: LocationService,
    private _employeeService: EmployeeService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerPurpose = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));

    this.Purpose = [];
    this.getAllPurpose();

  }
  ngAfterViewInit(): void {
    this.PurposeColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
      { field: "PurposeName", title: 'Purpose Name', filter: true, sortable: true, width: 150 },
      { field: "PurposeCode", title: 'Code', filter: true, sortable: true, width: 100 },
      //{ field: "PurposeOrder", title: 'Order', filter: true, sortable: true, width: 100 },
      //{ field: "PurposeDescription", title: 'Description', filter: true, sortable: true, width: 150 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._PurposeService.getAllPurpose('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((Purpose: Array<Purpose>) => {
      this.Purpose = {
        data: Purpose,
        total: Purpose[0] ? Purpose[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._PurposeService.getAllPurpose(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((Purpose: Array<Purpose>) => {
        this.Purpose = {
          data: Purpose,
          total: Purpose[0] ? Purpose[0].TotalCount : 0
        }
       

      });
    }
  }
  getAllPurpose() {
    this._PurposeService.getAllPurpose('', Number(this.defaultPageSize), 1, 0, 0).subscribe((Purpose: Array<Purpose>) => {
      this.Purpose.DateOfFormation = new Date(this.Purpose.DateOfFormation)

      this.Purpose = Purpose;
      for (let i = 0; i < Purpose.length; i++) {
        this.Purpose[i].DateOfFormation = this.pipe.transform(this.Purpose[i].DateOfFormation, "dd/MM/yyyy");
      }
      this.Purpose = {
        data: Purpose,
        total: Purpose[0] ? Purpose[0].TotalCount : 0
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._PurposeService.deletePurpose(this.selectedPurpose.Purpose_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearPurpose();
            this.getAllPurpose();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerPurpose = new PageHeader();
    headerPurpose.PageCaption = "Agenda Purpose";
    headerPurpose.IconClass = "bi bi-shield-shaded";
    return headerPurpose;
  }

  deletePurpose(event: any) {
    if (event.seletedRows[0]) {
      this.selectedPurpose.Purpose_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Agenda Purpose",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addPurpose(event: any) {
    this.listView = false;
    this.clearPurpose();

    this.formCaption = "Add Purpose";
  }

  editPurpose(event: any): void {
    if (event.seletedRows[0]) {
      this._PurposeService.viewPurpose(event.seletedRows[0]).subscribe((Purpose: Array<Purpose>) => {
        let editEnity = Purpose[0] ? Purpose[0] : new this.Purpose();

        if (editEnity) {

          this.editingEntity = editEnity;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Purpose";

          this.entity.EntityMetaData = [
            { FieldName: 'PurposeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Purpose Name is required' },
            { FieldName: 'PurposeCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            // { FieldName: 'PurposeOrder', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Purpose Order is required' },
            // { FieldName: 'PurposeDescription', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Purpose Description is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    if (parseInt(this.entity.PurposeCode) == 0) {
      this.notification.showWarning('Zero not allowed');
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._PurposeService.checkDuplication(this.entity.PurposeCode, this.entity.Purpose_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Purpose already exists');
          this.saveDisabled = false;
        }
        else {
          this._PurposeService.savePurpose(this.entity).subscribe(() => {
            if (this.entity.Purpose_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');

            }
            else {
              this.notification.showSuccess('Updated Successfully');

            }
            this.listView = true;
            this.clearPurpose();
            this.getAllPurpose();
          })
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }

  goToBackTab(): void {

    this.listView = true;

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllPurpose();
  }

  refreshDepartments(event: any): void {
    this.Purpose = [];
    this.getAllPurpose();
  }

  clearPurpose(): void {
    this._selectedPurpose = {};

    this.entity = new Purpose();

    this.saveDisabled = false;

  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  onPaste(event: any) {
    let Data = event.Data;
    let regexp = new RegExp('[^-_().;:,!a-zA-Z0-9/ ]');
    let pastedText = Data.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^a-zA-Z0-9-()._ ]/g, '');
    (<HTMLInputElement>document.getElementById('bindingId')).value = trimmedText;
    if (test) {
      event.preventDefault();
    }
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Purpose_Id = dataItem.Purpose_Id;
    this.details = [];
    this._PurposeService.viewPurpose(this.entity.Purpose_Id).subscribe((Purpose: Array<Purpose>) => {
      this.opened = true;
      this.details = Purpose[0];
    })}
}

